import { Box,FormControlLabel, RadioGroup, Typography } from '@mui/material';
import styles from './volunteer.module.scss';
import React, { useEffect, useState } from 'react';
import GeneralVolunteer from './generalVolunteer';
import RegisterForm from './volunteerRegistration';
import { CustomRadioButton } from '../common/StyledComponents/StyledFields';

const emailInfo = () => {
   return (
      <Box className={styles.emailData}>
         <Typography className={styles.info}>
            HCCC needs volunteers in various functional areas such as maintenance, publicity, youth
            and education activities, food preparation and distribution, hundi collections, etc.
         </Typography>
         <a href="mailto:volunteer.livermoretemple@gmail.com" className={styles.email} >
            volunteer.livermoretemple@gmail.com
         </a>
      </Box>
   );
};

const Volunteer = (): JSX.Element => {
   const [selectedValue, setSelectedValue] = useState<string>('email');

   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setSelectedValue((event.target as HTMLInputElement).value);
   };
   useEffect(() => {
      window.scrollTo(0, 200); // Scroll to the top of the page
      // Find the specific heading element by its ID or class name
      const VolunteerRegistratration = document.getElementById('VolunteerRegistratration');
      if (VolunteerRegistratration) {
         VolunteerRegistratration.scrollIntoView({ behavior: 'smooth' }); // Scroll to the heading
      }
  }, []);
   return (
      <Box className={styles.mainContainer}>
         <Typography className={styles.mainHeading}>Volunteer Registration</Typography>
         <Box className={styles.allFeildsAndData}>
            <RadioGroup className={styles.allFields} value={selectedValue} onChange={handleChange}>
               <FormControlLabel
                  className={styles.singleFeild}
                  control={
                     <CustomRadioButton
                        value="email"
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 6 } }}
                     />
                  }
                  label="Email"
                  classes={{ label: styles.customLabelStyle }}
               />
               <FormControlLabel
                  className={styles.singleFeild}
                  control={
                     <CustomRadioButton
                        value="general"
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 6,color:"grey" }, cursor:"not-allowed" }}
                     />
                  }
                  disabled
                  label="General Volunteer"
                  classes={{ label: styles.customLabelStyle }}
               />
               <FormControlLabel
                  className={styles.singleFeild}
                  control={
                     <CustomRadioButton
                        value="newYear"
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 6 } }}
                     />
                  }
                  label="New Year Volunteer"
                  classes={{ label: styles.customLabelStyle }}
               />
            </RadioGroup>
            {selectedValue === 'email' && emailInfo()}
            {selectedValue === 'general' && <GeneralVolunteer />}
            {selectedValue === 'newYear' && <RegisterForm />}
         </Box>
      </Box>
   );
};

export default Volunteer;
